import { useEffect, useState } from 'react';
import { NavigationContainer, createNavigationContainerRef } from '@react-navigation/native';
import { ActivityIndicator, View } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import RootNavigator from './src/navigation/RootNavigator';
import MiniPlayer from './src/components/MiniPlayer';
import { PlaybackProvider, usePlayback } from './src/context/PlaybackContext';
import { RootStackParamList } from './src/navigation/RootNavigator';
import { bootstrapAuthStorage } from './src/api/auth';
import colors from './src/theme';

const navigationRef = createNavigationContainerRef<RootStackParamList>();

function AppMiniPlayer() {
  const playback = usePlayback();

  return (
    <MiniPlayer
      onOpen={() => {
        playback.setMinimized(false);
        if (navigationRef.isReady()) {
          navigationRef.navigate('Player', playback.params);
        }
      }}
    />
  );
}

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    bootstrapAuthStorage().finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgb(242, 249, 253)' }}>
        <ActivityIndicator color={colors.button} />
      </View>
    );
  }

  return (
    <PlaybackProvider>
      <NavigationContainer ref={navigationRef}>
        <RootNavigator />
        <AppMiniPlayer />
        <StatusBar style="dark" />
      </NavigationContainer>
    </PlaybackProvider>
  );
}
